import React from 'react';

function NotFoundModule(props) {
    return (
        <div className="container mx-auto">
            Route not found
        </div>
    );
}

export default NotFoundModule;